import {LineupsMemberStatsViewModel} from "../../../domain/yard/lineups/lineups-member/stats/lineups-member.stats.view-model";
import {BaseViewModel} from "../../../infrastructure/models/base-view-model";
import {OrderByPositionViewModel} from "../../../domain/yard/lineups/statsCategory/orderByPosition/order-by-position.view-model";
import {computed} from "mobx";
import {StatsCategoryViewModel} from "../../../domain/yard/lineups/statsCategory/stats-category.view-model";

export class CompetitorPlayersStatsModuleStatsListViewModel extends BaseViewModel {
  stats: Array<LineupsMemberStatsViewModel>;
  statsCategory: StatsCategoryViewModel;
  playerPositionId: Number;

  constructor(stats: Array<LineupsMemberStatsViewModel>, statsCategory: StatsCategoryViewModel, playerPositionId: Number) {
    super()

    this.stats = stats;
    this.statsCategory = statsCategory;
    this.playerPositionId = playerPositionId;
  }

  @computed get order(): Number {
    const order: Number = this.statsCategory.orderByPosition?.find((item: OrderByPositionViewModel) => item.position === this.playerPositionId)?.positionOrder

    return order || this.statsCategory.orderLevel;
  }

  @computed get title(): String {
    const title: String = this.statsCategory.name;

    return title;
  }
}